const showAllRows = (table) => {
  if (!table) throw Error('No table found');

  const tableRows = [...table.querySelectorAll('tbody tr')];
  tableRows.forEach((row) => row.classList.remove('hidden'));
};

export default showAllRows;
